import styled from 'styled-components';

export const FilterSeparator = styled.div`
  padding: 16px 0;
  font-weight: 500;
  font-size: 16px;
  color: #262626;
`;
